/**
 * Overrides `AppNav` from  'smooth-doc/src/components/AppNav'
 */

import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql, navigate, withPrefix } from "gatsby";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useColorMode } from "@xstyled/styled-components";
import {
  Nav,
  NavList,
  NavListItem,
  NavLink,
  ColorModeSwitcher,
} from "smooth-doc/components";

import Search from "./Search";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  whiteColor: {
    color: "white",
  },
  addSelectPadding: {
    "& .MuiSelect-select": {
      paddingLeft: "1rem",
    },
  },
}));

export function AppNav() {
  const classes = useStyles();
  const [theme, setTheme] = useColorMode();
  const [deployments, setDeployments] = useState([]);
  const bucketPath = process.env.GATSBY_BUCKET_PATH || "";
  const bucketName = process.env.GATSBY_BUCKET_NAME || "test-smooth-doc";
  const deploymentsStub = process.env.GATSBY_DEPLOYMENTS_STUB || null;
  const prefix = withPrefix("/").replace(bucketPath, "").replaceAll("/", "");
  const currentDeployment = prefix === "" ? "development" : prefix;

  useEffect(() => {
    if (deploymentsStub) {
      try {
        setDeployments(JSON.parse(deploymentsStub));
      } catch {
        setDeployments([]);
      }
    } else {
      axios
        .request({
          url: `${bucketPath}/deployments.json`,
        })
        .then((res) => {
          setDeployments(res?.data || []);
        });
    }
  }, []);
  const data = useStaticQuery(graphql`
    query {
      allMdx {
        nodes {
          frontmatter {
            title
            description
          }
          slug
        }
      }
    }
  `);

  return (
    <Nav>
      <NavList>
        <NavListItem>
          <Search data={data.allMdx.nodes} theme={theme} />
        </NavListItem>
        <NavListItem style={{ marginRight: "1rem" }}>
          <Select
            className={classes.addSelectPadding}
            value={currentDeployment}
            disableUnderline
            classes={{
              root: theme === "dark" ? classes.whiteColor : "",
              icon: theme === "dark" ? classes.whiteColor : "",
            }}
          >
            <MenuItem value={currentDeployment} disabled>
              {currentDeployment}
            </MenuItem>
            {deployments
              .filter((deployment) => deployment !== currentDeployment)
              .map((deployment) => (
                <MenuItem
                  key={deployment}
                  onClick={() =>
                    navigate(
                      `https://docs.pathcore.com${bucketPath}/${deployment}`
                    )
                  }
                >
                  {deployment}
                </MenuItem>
              ))}
          </Select>
        </NavListItem>
        <NavListItem
          onClick={() =>
            theme === "light" ? setTheme("dark") : setTheme("light")
          }
        >
          <NavLink forwardedAs={ColorModeSwitcher} />
        </NavListItem>
      </NavList>
    </Nav>
  );
}
